import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  Divider,
  Paper,
  Card,
  CardContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
} from "@mui/material";
import { Facebook, YouTube, Twitter, Instagram } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#424242", // Darker grey shade
        color: "#fff",
        py: { xs: 4, sm: 6 }, // Responsive vertical padding
        px: { xs: 2, sm: 6 }, // Optional horizontal padding
        mt: 4,
      }}
    >
      <Grid container spacing={4}>
        {/* Footer Info or About */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            gutterBottom
            fontWeight="bold"
            sx={{
              display: "inline-block",
              borderBottom: "2px solid #ccc", // light grey underline
              pb: 0.5, // space between text and underline
            }}
          >
            About Tanween
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            This course focuses on teaching Modern Standard Arabic to help
            students better understand the Quran. It emphasizes mastering eight
            key sounds to improve language skills quickly and establish a strong
            foundation. The course adopts a unique 20/80 approach, teaching the
            20% of the language necessary to understand 80% of the Quran,
            allowing students to achieve results more efficiently than
            traditional methods. Memorization of grammar rules and tables is
            minimized, with the course focusing on vocabulary learning through
            repetition in lessons, assignments, and activities. Additionally,
            the course offers specially designed drills to help students grasp
            and reinforce key concepts in Arabic.
          </Typography>
        </Grid>

        {/* Follow Us Section */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            gutterBottom
            fontWeight="bold"
            sx={{
              display: "inline-block",
              borderBottom: "2px solid #ccc", // light grey underline
              pb: 0.5, // space between text and underline
            }}
          >
            Follow us
          </Typography>
          <Box display="flex" gap={3}>
            <IconButton
              href="https://www.facebook.com/profile.php?id=61558834314332"
              target="_blank"
              sx={{ color: "#3b5998" }}
            >
              <Facebook />
            </IconButton>
            <IconButton
              href="https://www.youtube.com/@tanweenarabic"
              target="_blank"
              sx={{ color: "#FF0000" }}
            >
              <YouTube />
            </IconButton>
            <IconButton
              href="https://twitter.com/Tanweenarabic"
              target="_blank"
              sx={{ color: "#1DA1F2" }}
            >
              <Twitter />
            </IconButton>
            <IconButton
              href="https://www.instagram.com/help.tanween/"
              target="_blank"
              sx={{ color: "#E1306C" }}
            >
              <Instagram />
            </IconButton>
          </Box>
        </Grid>
      </Grid>

      {/* Optional Bottom Footer */}
      <Box mt={4} textAlign="center" sx={{ opacity: 0.5 }}>
        <Typography variant="body2">
          © {new Date().getFullYear()} Your Company. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
